import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { isTVOS } from '../../helpers/Platform';

export const styles = StyleSheet.create({
  linearGradient: {
    flex: 1,
    height: Theme.px(540),
  },
  linearGradientWeb: {
    elevation: 499,
    flex: 1,
    height: Theme.px(540),
    paddingBottom: Theme.px(540),
    position: 'absolute',
    width: Theme.px(1920),
    zIndex: 499,
  },
  menu: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginLeft: Theme.px(90),
  },
  top: {
    alignItems: 'center',
    backgroundColor: isTVOS ? Theme.malibuBlue : Theme.transparent,
    flexDirection: 'row',
    height: isTVOS ? Theme.px(200) : Theme.px(540),
    justifyContent: 'flex-start',
    position: 'absolute',
    width: Theme.px(1920),
  },
  topWeb: {
    alignItems: 'center',
    backgroundColor: Theme.transparent,
    elevation: 500,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    position: 'absolute',
    top: 0,
    width: Theme.px(1920),
    zIndex: 500,
  },
});
